import React, { useState } from 'react';

import Trigger from './Trigger';
import TriggerHistory from './TriggerHistory';
import WorkflowList from '../workflow3/WorkflowList';

const MainForm = ({ setWorkflowType }) => {
  const [selectedTab, setSelectedTab] = useState('triggers');
  const handleSelectTab = (tab) => {
    setSelectedTab(tab);
    if (setWorkflowType) {
      // eslint-disable-next-line
      // eslint-disable-next-line
      if (tab == 'workflows') {
        setWorkflowType('workflow');
      } else {
        setWorkflowType('bot');
      }
    }
  };

  return (
    <div className="mx-auto h-full w-full max-w-3xl pt-10">
      <div className="w-full pt-2">
        <div className="bg-3 br-1 mx-auto flex w-fit gap-1 rounded-full border p-1 max-sm:text-xs">
          <button
            onClick={() => handleSelectTab('triggers')}
            className={`flex min-h-6 items-center gap-1 rounded-full border-0 px-3 py-1 text-xs transition-all duration-200 disabled:cursor-not-allowed ${
              selectedTab === 'triggers'
                ? 'bg-1 hover:text-s-text text-p-text font-semibold'
                : 'hover:text-s-text text-p-text bg-transparent font-normal'
            }`}
          >
            <span>Workflows</span>
          </button>
          <button
            onClick={() => handleSelectTab('workflows')}
            className={`flex min-h-6 items-center gap-1 rounded-full border-0 px-3 py-1 text-xs transition-all duration-200 disabled:cursor-not-allowed ${
              selectedTab === 'workflows'
                ? 'bg-1 hover:text-s-text text-p-text font-semibold'
                : 'hover:text-s-text text-p-text bg-transparent font-normal'
            }`}
          >
            <span>Graph Workflows</span>
          </button>
          <button
            onClick={() => handleSelectTab('history')}
            className={`flex min-h-6 items-center gap-1 rounded-full border-0 px-3 py-1 text-xs transition-all duration-200 disabled:cursor-not-allowed ${
              selectedTab === 'history'
                ? 'bg-1 hover:text-s-text text-p-text font-semibold'
                : 'hover:text-s-text text-p-text bg-transparent font-normal'
            }`}
          >
            <span>History</span>
          </button>
        </div>
        {selectedTab === 'triggers' && <Trigger />}
        {selectedTab === 'history' && <TriggerHistory />}
        {selectedTab === 'workflows' && <WorkflowList />}
      </div>
    </div>
  );
};

export default MainForm;
